import { atom } from "recoil"

export const ImagesControllerState = atom({
    key: "imagesController",
    default: []
})